import React from 'react';
import { di } from '../../state/inversify.config';
import { IncidentListDomainService } from './incidentListDomainService';
import { useQuerySync } from '../../state/queryParams/useQuerySync';
import { IncidentListQueryService } from './incidentList.queryParam.service';
import { IncidentsListDumb } from './incidentList.dumb';

export const IncidentsListPage = () => {
  const incidentListQueryService = di.get<IncidentListQueryService>(
    IncidentListQueryService,
  );

  useQuerySync(incidentListQueryService);

  const incidentListDomainService = di.get<IncidentListDomainService>(
    IncidentListDomainService,
  );
  const user = incidentListDomainService.useUserSelector();

  const openIncidents =
    incidentListDomainService.useOpenIncidentByPlayerSelector();

  const closedIncidents =
    incidentListDomainService.useClosedIncidentByPlayerSelector();

  return (
    <IncidentsListDumb
      user={user}
      openIncidents={openIncidents}
      closedIncidents={closedIncidents}
    />
  );
};
